import { WorkflowLevelAdvancementAPI } from '@core/typings/api/workflow-level-advancement.typing';
import { WorkflowLevelAutomationAPI } from '@core/typings/api/workflow-level-automation.typing';
import { Automation } from '@core/typings/ui/automation.typing';
import { DebounceFactory, TableDataFactory } from '@yourcause/common';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class WorkflowLevelAutomationState extends BaseYcState {
  readonly WorkflowObjects: Automation.ObjectConfig<string, string>[];
  readonly workflowAutomationDetail: {
    [id: number]: WorkflowLevelAutomationAPI.WorkflowLevelAutomationRuleSetDetailModel;
  } = {};
  readonly assignmentTableDataFactory: TableDataFactory<WorkflowLevelAutomationAPI.WorkflowLevelAutomationRuleSetForUi>;


  readonly WorkflowAdvancementObjects: Automation.ObjectConfig<string, string>[];
  readonly workflowAdvancementDetail: {
    [id: number]: WorkflowLevelAdvancementAPI.WorkflowLevelRoutingAutomationRuleSetDetailModel;
  } = {};
  readonly advancementTableDataFactory: TableDataFactory<WorkflowLevelAdvancementAPI.WorkflowLevelRoutingAutomationRuleSetForUi>;

  readonly workflowForms: {
    [workflowId: number]: WorkflowLevelAutomationAPI.WorkflowFormDisplay[];
  } = {};
  readonly assignmentHistoryTableDataFactory: DebounceFactory<WorkflowLevelAutomationAPI.WorkflowLevelAutomationApplication>;
  readonly routingHistoryTableDataFactory: DebounceFactory<WorkflowLevelAdvancementAPI.WorkflowLevelAutomationApplication>;
}
